import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Autotext, Test } from "@app/definitions/types"
import { getCheckedIds } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { UpdateTestComponent } from "@app/update-test/update-test.component"
import { TestanswersFillComponent } from "@app/testanswers-fill/testanswers-fill.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

@Component({
	selector: "app-tests-menu",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ModalWrapComponent,
		UpdateTestComponent,
		TestanswersFillComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./tests-menu.component.html",
})
export class TestsMenuComponent extends Modalable {
	modalProps: any = null
	tests: Test[] = [] //the list of current autoTexts
	@Input() patient_id: number = 0
	@Input() in_followup: boolean = false
	anyChecked: boolean = false
	isSendingInvite: boolean = false

	ngOnInit() {
		//when called to open get the autoTexts from DB
		this.getTests()
	}

	async getTests() {
		this.tests = this.store.getActiveTests()
	}

	closeIfValue(ret: any = null) {
		ret && this.onClose.emit(ret)
	}
	openTestAnswersModal(id: any) {
		this.modalProps = { name: "testanswers-fill", test_id: id }
	}

	async openUpdateTest(test: any) {
		this.modalProps = { name: "update-test", test }
	}

	onCheck(test: Test, isChecked: boolean) {
		test.checked = isChecked
		this.anyChecked = this.tests.some((it) => it.checked)
	}
	async sendInvite(arr: any[]) {
		this.isSendingInvite = true
		await this.store.sendInviteCommon(
			arr,
			this.patient_id,
			{
				test_ids: getCheckedIds(this.tests),
			},
			true
		)
		this.isSendingInvite = false
	}
}
